<template>
  <s-form @submit="saveGathering">
    <fieldset class="m-form-fieldset m-form-fieldset--no-margin">
      <div class="h-grid h-grid--justify-content-center h-grid--row-gutter">
        <div class="h-grid__col h-grid__col--sm-10 h-grid__col--md-8 h-remove-child-margin">
          <h2 class="a-form-subtitle">{{ $t('form-gathering-location-section') }}</h2>

          <!-- L'élément est présent dans la maquette mais pas dans le code -->
          <p class="a-label-accent" v-if="false">Indication pour remplir le bloc de champs lieu</p>

          <p class="m-form-group">
            <label class="a-form-label" for="locationType">
              {{ $t('label-edit-gathering-locationType') }}<required-form-field />
              <span class="m-form-group__note m-form-group__note--small">{{ $t('detail-label-gathering-locationType') }}</span>
              <span class="m-form-group__note m-form-group__note--small">{{ $t('label-edit-gathering-public-information') }}</span>
            </label>
            <input class="a-form-control" id="locationType" v-model.trim="$v.locationType.$model" autocomplete="edit-gathering location-type" />
            <span v-if="$v.locationType.$dirty">
              <span class="m-form-group__error" v-if="!$v.locationType.required">{{ $t('error-field-required') }}</span>
            </span>
          </p>

          <administrative-region-select v-model.trim="$v.region.$model">
            <span v-if="$v.region.$dirty">
              <span class="m-form-group__error" v-if="!$v.region.minValue">{{ $t('error-field-required') }}</span>
            </span>
          </administrative-region-select>

          <p class="m-form-group">
            <googlemap-autocomplete @place="setPlace" v-model.trim="$v.address.$model" :required="true" is-public-information>
              <template>
                <span v-if="$v.address.$dirty || $v.latitude.$dirty">
                  <span class="m-form-group__error" v-if="!$v.address.required">{{ $t('error-field-required') }}</span>
                  <span class="m-form-group__error" v-if="!$v.latitude.required">{{ $t('error-lat-long-required') }}</span>
                </span>
              </template>
            </googlemap-autocomplete>
          </p>

          <hr />
        </div>
        <div class="h-grid__col h-grid__col--sm-10 h-grid__col--md-8">
          <h2 class="a-form-subtitle">{{ $t('form-gathering-detail-section') }}</h2>

          <!-- L'élément est présent dans la maquette mais pas dans le code -->
          <p class="a-label-accent" v-if="false">Indication pour remplir le blocs détails de rassemblement</p>

          <legend>{{ $t('edit-gathering-entrepreneurs-info-title') }}</legend>
          <p class="a-form-radio a-form-radio--block">
            <input type="radio" name="gatheringType" id="privateGathering" :value="false" v-model="isPublic" autocomplete="edit-gathering gathering-type-private" />
            <label for="privateGathering">
              {{ $t('label-gathering-type-private') }}
              <span class="m-form-group__note m-form-group__note--small">{{ $t('gathering-private-explanation-text') }}</span>
            </label>
          </p>
          <p v-show="!isPublic">
            <label class="a-form-label" for="privatePassword"> {{ $t('gathering-private-password-label') }}<required-form-field /></label>
            <input class="a-form-control" id="privatePassword" v-model.trim="$v.privatePassword.$model" />
            <span v-if="$v.privatePassword.$dirty">
              <span class="m-form-group__error" v-if="!$v.privatePassword.privatePasswordRequiredValidator">{{ $t('error-field-required') }}</span>
              <span class="m-form-group__error" v-if="!$v.privatePassword.privatePasswordFormatValidator">{{ $t('error-field-gathering-private-password-format') }}</span>
            </span>
          </p>
          <p class="a-form-radio a-form-radio--block">
            <input type="radio" id="publicGathering" name="gatheringType" :value="true" v-model="isPublic" autocomplete="edit-gathering gathering-type-public" />
            <label for="publicGathering">
              {{ $t('label-gathering-type-public') }}
              <span class="m-form-group__note m-form-group__note--small">{{ $t('gathering-public-explanation-text') }}</span>
            </label>
          </p>

          <div class="m-form-group" style="padding-left: 30px;">
            <div class="h-grid">
              <div class="h-grid__col h-grid__col--sm-6">
                <span>{{ $t('gathering-registration-status') }}</span>
                <p v-if="!registrationClosed">
                  <span class="m-form-group__note m-form-group__note--small">{{ $t('gathering-registration-open-text') }}</span>
                </p>
                <p v-else>
                  <span class="m-form-group__note m-form-group__note--small">{{ $t('gathering-registration-cloase-text') }}</span>
                </p>
              </div>
              <div class="h-grid__col h-grid__col--sm-6">
                <p>
                  <button class="a-btn-primary-outline a-btn-primary-outline--small" type="button" v-if="!registrationClosed" @click="interruptRegistrations">
                    {{ $t('edit-gathering-interrupt-registrations-btn') }}
                  </button>
                  <button class="a-btn-primary-outline a-btn-primary-outline--small" type="button" v-else @click="reactivateRegistrations">
                    {{ $t('edit-gathering-reactivate-registrations-btn') }}
                  </button>
                </p>
              </div>
            </div>
          </div>

          <div class="o-panel" v-bind:class="{ 'o-panel--open': showMarkAsFullPanelOpen }">
            <div class="o-panel__head">
              <h2 class="o-panel__title">{{ $t('gathering-mark-full-confirmation-title') }}</h2>
              <button type="button" class="o-panel__close" @click="hideMarkAsFullPanel">{{ $t('panel-close') }}</button>
            </div>
            <div class="o-panel__content">
              <confirmation-popup :text="$t('gathering-mark-full-confirmation-text')" :actions="markAsFullActions" />
            </div>
          </div>
          <div class="o-panel__overlay" @click="hideMarkAsFullPanel"></div>

          <p class="m-form-group">
            <label class="a-form-label" for="nbKiosk"> {{ $t('label-edit-gathering-nbKiosk') }}<required-form-field /></label>
            <span class="m-form-group__note m-form-group__note--small">{{ $t('gathering-available-places-explanation-text') }}</span>
            <input class="a-form-control a-form-control--number" id="nbKiosk" type="Number" v-model.trim="$v.nbKiosk.$model" autocomplete="edit-gathering nb-kiosk" placeholder="Nombre" />
            <span v-if="$v.nbKiosk.$dirty">
              <span class="m-form-group__error" v-if="!$v.nbKiosk.required">{{ $t('error-field-required') }}</span>
              <span class="m-form-group__error" v-if="!$v.nbKiosk.minValue">{{ $t('error-field-required') }}</span>
            </span>
          </p>

          <div class="m-form-group h-grid">
            <div class="h-grid__col h-grid__col--md-6">
              <label class="a-form-label" for="openingTime"
                >{{ $t('label-edit-gathering-openingTime') }}<required-form-field /><span class="m-form-group__note m-form-group__note--small">{{
                  $t('label-edit-gathering-public-information')
                }}</span></label
              >
              <vue-timepicker
                class="a-form-control"
                id="openingTime"
                hide-disabled-items
                :hour-range="[8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]"
                :minute-interval="15"
                v-model.trim="$v.openingTime.$model"
              />
              <span v-if="$v.openingTime.$dirty">
                <span class="m-form-group__error" v-if="!$v.openingTime.required || !$v.openingTime.timeValidator">{{ $t('error-field-required') }}</span>
              </span>
            </div>

            <div class="h-grid__col h-grid__col--md-6">
              <label class="a-form-label" for="closingTime"
                >{{ $t('label-edit-gathering-closingTime') }}<required-form-field /><span class="m-form-group__note m-form-group__note--small">{{
                  $t('label-edit-gathering-public-information')
                }}</span></label
              >
              <vue-timepicker
                class="a-form-control"
                id="closingTime"
                hide-disabled-items
                :hour-range="[8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]"
                :minute-interval="15"
                v-model.trim="$v.closingTime.$model"
              />
              <span v-if="$v.closingTime.$dirty">
                <span class="m-form-group__error" v-if="!$v.closingTime.required || !$v.closingTime.timeValidator">{{ $t('error-field-required') }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </fieldset>

    <action-buttons
      :showSubmit="false"
      :isSubmitted="isSubmitted"
      :isAuthorized="isAuthorized"
      :errors="errors"
      @saveAndBack="saveAndBack"
      @saveAndQuit="saveAndQuit"
      @saveAndContinue="saveAndContinue"
      @previewGathering="previewGathering"
    />
  </s-form>
</template>

<script>
import SForm from '@/components/form/form'
import { required, minValue } from 'vuelidate/lib/validators'
import ActionButtons from '@/components/pages/gathering/edit-steps/action-buttons'
import GooglemapAutocomplete from '@/components/form/googlemap-autocomplete'
import AdministrativeRegionSelect from '@/components/form/administrative-region-select'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import ConfirmationPopup from '@/components/popup/confirmation-popup'
import RequiredFormField from '@/components/ui/required-form-field'
import FormHelper from '@/helpers/form'

import GatheringService from '@/services/gathering'
import LoaderService from '@/services/loader'

import { YesNoList } from '@/mixins/form/yes-no-list'

const timeValidator = function(value) {
  if (value.indexOf(':mm') !== -1 || value.indexOf('HH:') !== -1) return false
  return true
}

const privatePasswordRequiredValidator = function(value) {
  if (!this.isPublic && value.trim() === '') return false
  return true
}

const privatePasswordFormatValidator = function(value) {
  if (!this.isPublic && !FormHelper.isValidGatheringPrivatePassword(value)) return false
  return true
}

export default {
  components: {
    SForm,
    ActionButtons,
    GooglemapAutocomplete,
    AdministrativeRegionSelect,
    VueTimepicker,
    ConfirmationPopup,
    RequiredFormField
  },
  mixins: [YesNoList],
  props: {
    value: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      locationType: this.value.LocationType !== null ? this.value.LocationType : '',
      region: this.value.Region !== null ? this.value.Region : null,
      address: this.value.Address !== null ? this.value.Address : '',
      latitude: this.value.Latitude !== null ? this.value.Latitude : '',
      longitude: this.value.Longitude !== null ? this.value.Longitude : '',
      postalcode: '',
      city: '',
      isPublic: this.value.IsPublic !== null ? this.value.IsPublic : false,
      nbKiosk: this.value.NbKiosk !== null ? this.value.NbKiosk : null,
      openingTime: this.value.OpeningTime !== null ? this.value.OpeningTime : '',
      closingTime: this.value.ClosingTime !== null ? this.value.ClosingTime : '',
      isSubmitted: this.value.IsSubmitted !== null ? this.value.IsSubmitted : false,
      isAuthorized: this.value.IsPublish !== null ? this.value.IsPublish : false,
      registrationClosed: this.value.RegistrationClosed !== null ? this.value.RegistrationClosed : false,
      showMarkAsFullPanelOpen: false,
      markAsFullActions: [
        { key: 'markAsFullGathering_yes', label: this.$t('popup_confirm_label'), click: this.markAsFull },
        { key: 'markAsFullGathering_no', label: this.$t('popup_dismiss_label'), click: this.hideMarkAsFullPanel }
      ],
      privatePassword: this.value.PrivatePassword !== null ? this.value.PrivatePassword : ''
    }
  },
  validations: {
    locationType: {
      required
    },
    address: {
      required
    },
    latitude: {
      required
    },
    region: {
      minValue: minValue(1)
    },
    nbKiosk: {
      required,
      minValue: minValue(0)
    },
    privatePassword: {
      privatePasswordRequiredValidator,
      privatePasswordFormatValidator
    },
    openingTime: {
      required,
      timeValidator
    },
    closingTime: {
      required,
      timeValidator
    }
  },
  computed: {
    gathering: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    errors: function() {
      const errors = []

      if (this.$v.$invalid) {
        if (!this.$v.locationType.required) {
          errors.push(this.$t('gathering-locationType-error-text'))
        }

        if (!this.$v.address.required) {
          errors.push(this.$t('gathering-adress-error-text'))
        } else if (!this.$v.latitude.required) {
          errors.push(this.$t('gathering-addressformat-error-text'))
        }

        if (!this.$v.region.minValue) {
          errors.push(this.$t('gathering-region-error-text'))
        }

        if (!this.$v.nbKiosk.required || !this.$v.nbKiosk.minValue) {
          errors.push(this.$t('gathering-nbKiosk-error-text'))
        }

        if (!this.$v.openingTime.required || !this.$v.openingTime.timeValidator || !this.$v.closingTime.required || !this.$v.closingTime.timeValidator) {
          errors.push(this.$t('gathering-openHours-error-text'))
        }

        if (!this.$v.privatePassword.privatePasswordRequiredValidator) {
          errors.push(this.$t('gathering-private-password-error-text'))
        }

        if (!this.$v.privatePassword.privatePasswordFormatValidator) {
          errors.push(this.$t('gathering-private-password-format-error-text'))
        }
      }

      return errors
    }
  },
  methods: {
    saveGathering: async function() {
      LoaderService.showLoader()

      const request = {
        gatheringId: this.gathering.Id
      }

      if (this.locationType !== this.gathering.LocationType) {
        request.locationType = { value: this.locationType }
      }

      if (this.region !== this.gathering.Region) {
        request.region = { value: this.region }
      }

      if (this.address !== this.gathering.Address) {
        request.address = { value: this.address }
        request.latitude = { value: this.latitude }
        request.longitude = { value: this.longitude }
        request.postalcode = { value: this.postalcode }
        request.city = { value: this.city }
      }

      if (this.isPublic !== this.gathering.IsPublic) {
        request.isPublic = { value: this.isPublic }
      }

      if (this.isPublic) {
        request.privatePassword = ''
      } else if (this.privatePassword !== this.gathering.PrivatePassword) {
        request.privatePassword = this.privatePassword
      }

      if (this.registrationClosed !== this.gathering.RegistrationClosed) {
        request.registrationClosed = { value: this.registrationClosed }
      }

      if (this.nbKiosk !== this.gathering.NbKiosk) {
        request.nbKiosk = { value: this.nbKiosk }
      }

      if (this.openingTime !== this.gathering.OpeningTime) {
        request.openingTime = { value: this.openingTime }
      }

      if (this.closingTime !== this.gathering.ClosingTime) {
        request.closingTime = { value: this.closingTime }
      }

      const response = await GatheringService.updateGathering(request)
      this.gathering = response
      LoaderService.hideLoader()
    },
    setPlace: function(place) {
      this.longitude = place.geometry.location.lng()
      this.latitude = place.geometry.location.lat()
      let vm = this

      place.address_components.forEach(function(c) {
        switch (c.types[0]) {
          case 'locality':
            vm.city = c.long_name
            break
          case 'postal_code':
            vm.postalcode = c.long_name
            break
        }
      })
    },
    interruptRegistrations: async function() {
      this.registrationClosed = true
    },
    reactivateRegistrations: async function() {
      this.registrationClosed = false
    },
    showMarkAsFull: function() {
      this.showMarkAsFullPanelOpen = true
    },
    hideMarkAsFullPanel: async function() {
      this.showMarkAsFullPanelOpen = false
    },
    canSave: function(forceValidation = false) {
      if (this.isSubmitted || this.isAuthorized || forceValidation) {
        this.$v.$touch()
        return !this.$v.$invalid
      }
      return true
    },
    saveAndBack: async function() {
      if (this.canSave()) {
        await this.saveGathering()
        this.$emit('saveAndBack')
      }
    },
    previewGathering: async function() {
      if (this.canSave()) {
        await this.saveGathering()
        this.$emit('previewGathering')
      }
    },
    saveAndQuit: async function() {
      if (this.canSave()) {
        await this.saveGathering()
        this.$emit('saveAndQuit')
      }
    },
    saveAndContinue: async function() {
      if (this.canSave(true)) {
        await this.saveGathering()
        this.$emit('saveAndContinue')
      }
    }
  },
  watch: {
    isPublic: function(val) {
      if (!val) {
        this.registrationClosed = false
      }
    }
  }
}
</script>

<style lang="scss">
.display-time {
  border: 0 !important;
  color: inherit;
  font-family: 'Proxima', sans-serif;
  height: auto !important;
  outline: none;
  padding: 0 !important;
  width: 100% !important;
}

.vue__time-picker {
  width: 100%;
}

.vue__time-picker .clear-btn {
  color: color('error');
  font-size: 1.4em;
  margin-block-start: 0;
}

.vue__time-picker .dropdown ul li:not([disabled]).active,
.vue__time-picker .dropdown ul li:not([disabled]).active:hover,
.vue__time-picker .dropdown ul li:not([disabled]).active:focus {
  background: #7667a7;
}
</style>
